import { render, staticRenderFns } from "./ItemGroupTile.vue?vue&type=template&id=3ca13da0&"
import script from "./ItemGroupTile.vue?vue&type=script&lang=ts&"
export * from "./ItemGroupTile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports